.spinner {
  margin: auto;
}
